<template>
    <div class="form-horizontal">
        <div class="success_message">{{ successMessage }}</div>

        <div class="form-group">
            <label class="col-md-3">Label title</label>
            <div class="col-md-9">
                <input v-model="formData.labelName" type="text" class="form-control">
            </div>
        </div>

        <div class="form-group">
            <label class="col-md-3">Label color</label>
            <div class="col-md-2 color-pick">
                <chrome-picker :value="this.formData.color" @input="updateColor" />
            </div>
        </div>

        <div class="form-group">
            <label class="col-md-3">Parent Label</label>
            <div class="col-md-9">
                <select v-model="formData.parentLabel" class="form-control">
                    <!-- Options for parent label -->
                    <option v-for="label in labels" :value="label.id" v-if="label.parent_id == null || label.parent_id == 0">{{ label.label_name }}</option>
                </select>
            </div>
        </div>

    </div>
</template>

<script>
import {getLabels} from "@/modules/common/api";
import { Chrome } from 'vue-color';
import {required} from "vee-validate/dist/rules";

export default {
    name: "CreateNewLabelTemplate",
    components: {'chrome-picker': Chrome},
    props:{
        formData:required,
        allLabels: null
    },
    data() {
        return {
            labels:[],
        };
    },
    methods:{
        updateColor(newColor) {
            this.formData.color = newColor.hex.slice(1);
        },
    },
    mounted() {
      if(this.allLabels)
        this.labels = this.allLabels
      else {
        getLabels().then((response) => {
          this.labels = response.data;
        });
      }
    },
}
</script>


<style scoped>

</style>